import { render } from "./ProgramaLealtadRewardNew.vue?vue&type=template&id=13bf3048&scoped=true"
import script from "./ProgramaLealtadRewardNew.vue?vue&type=script&lang=js"
export * from "./ProgramaLealtadRewardNew.vue?vue&type=script&lang=js"

import "./ProgramaLealtadRewardNew.vue?vue&type=style&index=0&id=13bf3048&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bf3048"]])

export default __exports__